import { Component, OnInit, HostBinding } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';

import { ScrollToService } from 'app/shared/scroll-to.service';
import { AnalyticsService } from 'app/shared/analytics/analytics.service';
import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { FluxoVestibularService } from '../shared/fluxoVestibular.service';
import { environment } from '../../../../environments/environment';

import { DadosVestibular, InscricaoResponse } from 'models/dados-vestibular';
import { BlockingSpinnerService } from 'app/core/blocking-spinner/blocking-spinner.service';
import { InscricaoService } from '../shared/inscricao.service';


@Component({
  moduleId: module.id.toString(),
  templateUrl: './nota-enem.component.html',
  styleUrls: ['./nota-enem.component.scss'],
  animations: [routerTransition],
})
export class NotaEnemComponent implements OnInit {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';

  dadosVestibular: DadosVestibular = undefined;
  dadosVestibularSubscription: Subscription;
  isReingresso = false;
  pontuacaoEnem = '';
  anoEnem = '';
  anos = [];
  numeroInscricao: any = '';

  public NOTA_MASK = [/([\d]+)/, /([\d]+)/, /([\d]+)/, '.',/([\d]+)/, /([\d]+)/];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fluxoVestibularService: FluxoVestibularService,
    private scrollTo: ScrollToService,
    private analytics: AnalyticsService,
    private blockingSpinnerService: BlockingSpinnerService,
    private incricaoService: InscricaoService,
  ) { }

  ngOnInit() {
    this.dadosVestibular = this.fluxoVestibularService.getDadosVestibular();
    if (!this.dadosVestibular) {
      return;
    }
    this.scrollTo.goTop();
    const anoHoje = new Date().getFullYear();
    this.anos = [anoHoje - 1, anoHoje - 2, anoHoje - 3, anoHoje - 4, anoHoje - 5, anoHoje - 6];
    this.analytics.registrar(
      `Vestibular`,
      `Fluxo ${this.dadosVestibular.vestibular.tipo}`,
      'Notas Enem',
    );
  }

  disableBtnProximo() {
    if (!this.pontuacaoEnem || !this.anoEnem || parseFloat(this.pontuacaoEnem)>1000.00 || parseFloat(this.pontuacaoEnem)<450) {
      return true;
    }
  }

  voltar() {
    this.fluxoVestibularService.voltarPasso();
    const rotaAnterior = this.fluxoVestibularService.rotaAnterior();
    this.router.navigate([`../${rotaAnterior}`], { relativeTo: this.route });
  }

  proximo() {
    this.blockingSpinnerService.show();
    this.fluxoVestibularService.setDadosVestibular({
      enem: {
        pontuacaoEnem: this.pontuacaoEnem,
        anoEnem: this.anoEnem,
      },
    });

    this.incricaoService.inscrever(this.fluxoVestibularService.getDadosVestibular()).then(
      (data: InscricaoResponse) => {
        this.numeroInscricao = data.numeroInscricao;

        this.fluxoVestibularService.setDadosVestibular({
          enem: {
            pontuacaoEnem: this.pontuacaoEnem,
            anoEnem: this.anoEnem,
          },
          agendamento: {
            numeroInscricao: this.numeroInscricao,
          },
        });
        this.dadosVestibular = this.fluxoVestibularService.getDadosVestibular();
        this.blockingSpinnerService.close();
        this.analytics.registrar(
          `Vestibular`,
          `Fluxo ${this.dadosVestibular.vestibular.tipo}`,
          'Finalização - Dados Enem',
        );
        this.nextStep();
      },

      resp => {
        console.error(resp.erro.mensagem);
        this.blockingSpinnerService.close();
      },
    );
  }

  nextStep() {
    this.fluxoVestibularService.proximoPasso();
    const proximaRota = this.fluxoVestibularService.proximaRota();
    this.router.navigate([`../${proximaRota}`], { relativeTo: this.route });
  }
}
